import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=79e5d19b&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"
import style0 from "./Slides.vue?vue&type=style&index=0&id=79e5d19b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5d19b",
  null
  
)

export default component.exports